export default "__VITE_ASSET__CXpgW4RP__"